"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _dealerDetails = _interopRequireDefault(require("../../styles/dealerDetails.css"));
var _checkProps = _interopRequireDefault(require("../../utils/checkProps"));
var _types = _interopRequireDefault(require("../types"));
var getAllUniqueDeparments = function getAllUniqueDeparments(departments, filterTags) {
  var allDepartments = departments.map(function (department) {
    return department.code;
  });
  if (filterTags) {
    filterTags.forEach(function (tag) {
      if (!allDepartments.includes(tag)) {
        allDepartments.push(tag);
      }
    });
  }
  return allDepartments;
};
var renderDepartmentLabel = function renderDepartmentLabel(params) {
  var salesLabel = params.salesLabel,
    servicesLabel = params.servicesLabel,
    usedCarsSalesLabel = params.usedCarsSalesLabel,
    bodyAndPaintLabel = params.bodyAndPaintLabel,
    departmentCode = params.departmentCode,
    additionalFilters = params.additionalFilters,
    theme = params.theme;
  var filterName = additionalFilters ? additionalFilters.find(function (filter) {
    return filter.value === departmentCode;
  }) : null;
  var departmentLabel = null;
  switch (departmentCode) {
    case 'sales':
      departmentLabel = salesLabel;
      break;
    case 'services':
      departmentLabel = servicesLabel;
      break;
    case 'usedcarssales':
      departmentLabel = usedCarsSalesLabel;
      break;
    case 'bodyandpaint':
      departmentLabel = bodyAndPaintLabel;
      break;
    default:
      departmentLabel = filterName ? filterName.label : null;
  }
  if (departmentLabel) {
    return /*#__PURE__*/_react["default"].createElement("li", {
      className: _dealerDetails["default"].departmentName + " " + theme.smallType,
      key: departmentCode
    }, departmentLabel);
  }
  return '';
};
var DealerDetailsDepartments = function DealerDetailsDepartments(_ref) {
  var dealerDepartments = _ref.dealerDepartments,
    dealerFilterTags = _ref.dealerFilterTags,
    theme = _ref.theme,
    salesLabel = _ref.salesLabel,
    servicesLabel = _ref.servicesLabel,
    usedCarsSalesLabel = _ref.usedCarsSalesLabel,
    bodyAndPaintLabel = _ref.bodyAndPaintLabel,
    additionalFilters = _ref.additionalFilters;
  if (!(0, _checkProps["default"])(dealerDepartments)) {
    return /*#__PURE__*/_react["default"].createElement("ul", {
      className: _dealerDetails["default"].departmentNames
    }, getAllUniqueDeparments(dealerDepartments, dealerFilterTags).map(function (departmentCode) {
      return renderDepartmentLabel({
        salesLabel: salesLabel,
        servicesLabel: servicesLabel,
        usedCarsSalesLabel: usedCarsSalesLabel,
        bodyAndPaintLabel: bodyAndPaintLabel,
        departmentCode: departmentCode,
        additionalFilters: additionalFilters,
        theme: theme
      });
    }));
  }
  return null;
};
var _default = DealerDetailsDepartments;
exports["default"] = _default;